var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.1381,
    cy: 22.4593,
    r: 22.3304,
    fill: "#E6F8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13962)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7354,
    height: 20.7354,
    transform: "translate(12.7703 12.0918)",
    fill: "#E6F8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4988 12.1797C17.9988 12.1797 13.4988 16.6797 13.4988 22.1797C13.4988 27.6797 17.9988 32.1797 23.4988 32.1797C28.9988 32.1797 33.4988 27.6797 33.4988 22.1797C33.4988 16.6797 28.9988 12.1797 23.4988 12.1797ZM21.4988 27.1797L16.4988 22.1797L17.9088 20.7697L21.4988 24.3497L29.0888 16.7597L30.4988 18.1797L21.4988 27.1797Z",
    fill: "#09B81D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7354,
    height: 20.7354,
    fill: "white",
    transform: "translate(12.7703 12.0918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentIcon);
export default __webpack_public_path__ + "static/media/PresentIcon.4950bdbc4e6d0e40074d60776e84f1d5.svg";
export { ForwardRef as ReactComponent };